import { useCallback } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  KOL_LIST_FETCH_BEGIN,
  KOL_LIST_FETCH_SUCCESS,
  KOL_LIST_FETCH_FAILURE,
  KOL_GROUP_MEMBER_LIST_FETCH_BEGIN,
  KOL_GROUP_MEMBER_LIST_FETCH_SUCCESS,
  KOL_GROUP_MEMBER_LIST_FETCH_FAILURE,
  UPDATE_KOL_LIST_FILTER,
} from "./constants";
import _ from "lodash";
import axios from "axios";
import { apiUrl } from "features/configure";
import { enqueueSnackbar } from "features/common/redux/actions";

export const KOL_FILTER_INITIAL_STATE = {
  kolListFilter: {
    page: 1,
    orderData: { sort: "xFollowers", order: -1 },
    search: "",
  },
};

export function fetchKolList({
  entityName,
  filter = KOL_FILTER_INITIAL_STATE.kolListFilter,
  signal = null,
}) {
  return async (dispatch, getState) => {
    dispatch({
      type: KOL_LIST_FETCH_BEGIN,
    });

    try {
      //   const result = await axios.post(
      //     `${apiUrl}/api/kol/${entityName}/kolList`,
      //     {
      //       ...filter,
      //     },
      //     {
      //       signal,
      //     }
      //   );
      //   dispatch({
      //     type: KOL_LIST_FETCH_SUCCESS,
      //     data: result.data.kols,
      //     kolListCount: result.headers["x-total-count"],
      //   });

      const kolList = [
        {
          _id: "1",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
        {
          _id: "2",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
        {
          _id: "3",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
        {
          _id: "4",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
      ];

      dispatch({
        type: KOL_LIST_FETCH_SUCCESS,
        data: kolList,
        kolListCount: kolList.length,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled", err.message);
      } else {
        console.log(err);
        dispatch({
          type: KOL_LIST_FETCH_FAILURE,
        });
        dispatch(
          enqueueSnackbar({
            message: _.get(
              err,
              "response.data.error",
              _.get(err, "response.data.message", "error")
            ),
            options: {
              variant: "error",
            },
          })
        );
      }
    }
  };
}

export function fetchKolGroupMemberList({
  entityName,
  filter = KOL_FILTER_INITIAL_STATE.kolListFilter,
  signal = null,
  groupId,
}) {
  return async (dispatch, getState) => {
    dispatch({
      type: KOL_GROUP_MEMBER_LIST_FETCH_BEGIN,
    });

    try {
      //   const result = await axios.post(
      //     `${apiUrl}/api/kol/${entityName}/kolGroupMemberList/${groupId}`,
      //     {
      //       ...filter,
      //     },
      //     {
      //       signal,
      //     }
      //   );
      //   dispatch({
      //     type: KOL_GROUP_MEMBER_LIST_FETCH_SUCCESS,
      //     data: result.data.kols,
      //     kolGroupMemberListCount: result.headers["x-total-count"],
      //   });

      const kolGroupMemberList = [
        {
          _id: "1",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
        {
          _id: "2",
          avatar: "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
          name: "test1",
          xHandle: "test1",
          verified: true,
          description: "Bitcoin is https://t.co/KbbYe745r3",
          xFollowers: 123,
          categories: [
            {
              color: "#C5E3FF",
              label: "DeFi",
              type: "category",
              value: "defi",
            },
            {
              color: "#C5E3FF",
              label: "Holder",
              type: "category",
              value: "holder",
            },
            {
              color: "#F1E5FF",
              label: "Whale",
              type: "category",
              value: "whale",
            },
            {
              color: "#F1E5FF",
              label: "NFT",
              type: "category",
              value: "nft",
            },
            {
              color: "#FEE",
              label: "Gaming",
              type: "category",
              value: "gaming",
            },
            {
              color: "#FFE8B7",
              label: "Opinion Leader",
              type: "category",
              value: "opinionLeader",
            },
            {
              color: "#FFE8B7",
              label: "SocialFi",
              type: "category",
              value: "socialFi",
            },
          ],
          etr: 7.9,
          ext: 7.8,
          originalTweetsRatio: 75,
          language: [
            { label: "English", value: "en" },
            { label: "Chinese", value: "zh" },
            { label: "Japanese", value: "jp" },
          ],
          location: [
            { label: "Taiwan", value: "taiwan" },
            { label: "India", value: "india" },
          ],
        },
      ];

      dispatch({
        type: KOL_GROUP_MEMBER_LIST_FETCH_SUCCESS,
        data: kolGroupMemberList,
        kolGroupMemberListCount: kolGroupMemberList.length,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled", err.message);
      } else {
        console.log(err);
        dispatch({
          type: KOL_GROUP_MEMBER_LIST_FETCH_FAILURE,
        });
        dispatch(
          enqueueSnackbar({
            message: _.get(
              err,
              "response.data.error",
              _.get(err, "response.data.message", "error")
            ),
            options: {
              variant: "error",
            },
          })
        );
      }
    }
  };
}

export function updateKolListFilter(data) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_KOL_LIST_FILTER,
      data,
    });
  };
}

export function useFetchKolList() {
  const dispatch = useDispatch();

  const {
    kolList,
    fetchKolListPending,
    fetchKolListDone,
    kolListCount,
    kolGroupMemberList,
    fetchKolGroupMemberListPending,
    fetchKolGroupMemberListDone,
    kolGroupMemberListCount,
    kolListFilter,
  } = useSelector(
    (state) => ({
      kolList: state.metadesk.kolList,
      fetchKolListPending: state.metadesk.fetchKolListPending,
      fetchKolListDone: state.metadesk.fetchKolListDone,
      kolListCount: state.metadesk.kolListCount,
      kolGroupMemberList: state.metadesk.kolGroupMemberList,
      fetchKolGroupMemberListPending:
        state.metadesk.fetchKolGroupMemberListPending,
      fetchKolGroupMemberListDone: state.metadesk.fetchKolGroupMemberListDone,
      kolGroupMemberListCount: state.metadesk.kolGroupMemberListCount,
      kolListFilter: state.metadesk.kolListFilter,
    }),
    shallowEqual
  );

  const fetchKolListAction = useCallback(
    (data) => {
      return dispatch(fetchKolList(data));
    },
    [dispatch]
  );

  const fetchKolGroupMemberListAction = useCallback(
    (data) => {
      return dispatch(fetchKolGroupMemberList(data));
    },
    [dispatch]
  );

  const updateKolListFilterAction = useCallback(
    (data) => {
      return dispatch(updateKolListFilter(data));
    },
    [dispatch]
  );

  return {
    kolList,
    kolGroupMemberList,
    fetchKolList: fetchKolListAction,
    fetchKolGroupMemberList: fetchKolGroupMemberListAction,
    updateKolListFilter: updateKolListFilterAction,
    fetchKolListDone,
    fetchKolListPending,
    kolListCount,
    kolGroupMemberListCount,
    fetchKolGroupMemberListPending,
    fetchKolGroupMemberListDone,
    kolListFilter,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case KOL_LIST_FETCH_BEGIN:
      return {
        ...state,
        fetchKolListPending: true,
      };
    case KOL_LIST_FETCH_SUCCESS:
      return {
        ...state,
        kolList: action.data,
        kolListCount: action.kolListCount,
        fetchKolListDone: true,
        fetchKolListPending: false,
      };
    case KOL_LIST_FETCH_FAILURE:
      return {
        ...state,
        fetchKolListPending: false,
      };

    case KOL_GROUP_MEMBER_LIST_FETCH_BEGIN:
      return {
        ...state,
        fetchKolGroupMemberListPending: true,
      };
    case KOL_GROUP_MEMBER_LIST_FETCH_SUCCESS:
      return {
        ...state,
        kolGroupMemberList: action.data,
        kolGroupMemberListCount: action.kolGroupMemberListCount,
        fetchKolGroupMemberListDone: true,
        fetchKolGroupMemberListPending: false,
      };
    case KOL_GROUP_MEMBER_LIST_FETCH_FAILURE:
      return {
        ...state,
        fetchKolGroupMemberListPending: false,
      };

    case UPDATE_KOL_LIST_FILTER:
      return {
        ...state,
        kolListFilter: {
          ...KOL_FILTER_INITIAL_STATE.kolListFilter, // 至少要有初始值
          ...action.data,
        },
      };

    default:
      return state;
  }
}
